import React from "react";
import { Div, Text, Button, Image } from "atomize";
import ImageLink from "./ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

const SolvedModalSlider = ({ content, next, prev }) => {
  return (
    <Div h="100%">
      <Div d="flex" flexDir={{ xs: "column", md: "row" }} h="100%">
        <Div flexGrow={{ xs: "inherit", md: "1" }}>
          <Div h="100%">
            <ImageLink link={content.image.description} h="100%">
              <Div
                align="center"
                bgImg={content.image.file.url}
                className="resource-image"
                pos="relative"
                bgSize="cover"
                bgPos="center"
                bg-repeat="no-repeat"
                h="100%"
                p={{ b: { lg: "111%", md: "130%", xs: "70%" } }}
              >
                <Div
                  pos="absolute"
                  top="0"
                  left="0"
                  w="100%"
                  h="100%"
                  bg="rgba(0, 0, 0, 0.41)"
                  d="flex"
                  align="center"
                  justify="center"
                >
                  <Image
                    src="../../images/solved-badge.svg"
                    h="3.5rem"
                    transform="rotate(-5deg)"
                  />
                </Div>
              </Div>
            </ImageLink>
          </Div>
        </Div>
        <Div flexGrow={{ xs: "1", md: "1.04" }}>
          <Div
            align="center"
            h="100%"
            d="flex"
            flexDir="column"
            justify="space-between"
            textAlign={{ lg: "left", md: "left", sm: "center", xs: "center" }}
            align={{
              lg: "flex-start",
              md: "flex-start",
              xs: "center",
            }}
            p={{
              x: { lg: "2.5rem", md: "1.9rem", xs: ".9rem" },
              y: { lg: "7.5rem", md: "3.5rem", xs: "1.2rem" },
            }}
          >
            <Div>
              <Text
                textWeight="600"
                className="slide-title"
                textSize="subheader4"
                textColor="dark"
              >
                {content.title}
              </Text>
              <Text m={{ t: ".63rem" }} className="slide-desc" textColor="dark">
                {content.description.description}
              </Text>
            </Div>
            <Div
              d={{ lg: "flex", md: "flex", xs: "flex" }}
              m={{ t: "1.25rem" }}
            >
              <Button
                className="slide-title button-0"
                bg="primary"
                rounded="xs"
                textColor="black"
                w="8.125rem"
                h="3.125rem"
                m={{ r: "1rem" }}
                style={{ lineHeight: "3.125rem" }}
                textWeight="600"
                onClick={prev}
              >
                Previous
              </Button>
              <Button
                className="slide-title button-1"
                style={{ lineHeight: "3.125rem" }}
                onClick={next}
                textColor="black"
                bg="primary"
                w="8.125rem"
                h="3.125rem"
                rounded="xs"
                textWeight="600"
              >
                Next
              </Button>
            </Div>
          </Div>
        </Div>
      </Div>
    </Div>
  );
};

export default SolvedModalSlider;
